import React from "react";
import {
  Stack,
  DayOfWeek,
  PrimaryButton,
  DefaultButton,
  IDropdownOption,
  Dropdown,
  Label,
  TooltipHost,
  Callout,
  DirectionalHint,
  FocusTrapZone,
  Calendar,
  TextField,
  Toggle,
  Checkbox,
  Text,
} from "office-ui-fabric-react";
import { useParams } from "react-router-dom";
import {
  ISearchTransactions,
  IDedicatedPduRemarks,
  IPowerReportConfigurations,
  IDataCenter,
} from "../../../vm";
import {
  getCustomerPowerPduReport,
  getCustomerRatedDetailsByDC,
  getDatacentersForACustomer,
  getPowerReportConfigurations,
  updateCustomerDedicatedPdu,
  updateCustomerDedicatedPduRemarks,
  updateCustomerRackwisePdu,
  updatePowerReportConfigurations,
} from "../../../services/customers/CustomerService";
import { ToastContext } from "../../common/ToastProvider";
import { API_URL, childrenGap, childrenGap8, DayPickerStrings } from "../../common/Constants";
import moment from "moment";
import Icon from "@mdi/react";
import {
  mdiCheck,
  mdiChevronDown,
  mdiChevronRight,
  mdiClose,
  mdiPencil,
} from "@mdi/js";
import { THEME } from "../../../utils/Styles";
import { Loading } from "../../../services/Loading";
import { Formik } from "formik";
import { CustomTextField } from "../../common/Library";
import NoDataTile from "../../common/NoDataTile";
import {
  getToken,
  parseJwt,
  toFixedValue,
} from "../../../services/UtilService";
import Datetime from "react-datetime";
import ViewUploadedReportDialog from "./ViewUploadedReportDialog";

export interface PduPowerTableProps {
  customerName: string;
}

let calendarButtonElement: HTMLElement;
var totalFloor = 0, ampsTotalValue = 0, kwhTotalValue = 0, kwTotalValue = 0, kvaTotalValue = 0;

// const DayPickerStrings = {
//   months: [
//     "January",
//     "February",
//     "March",
//     "April",
//     "May",
//     "June",
//     "July",
//     "August",
//     "September",
//     "October",
//     "November",
//     "December",
//   ],
//   shortMonths: [
//     "Jan",
//     "Feb",
//     "Mar",
//     "Apr",
//     "May",
//     "Jun",
//     "Jul",
//     "Aug",
//     "Sep",
//     "Oct",
//     "Nov",
//     "Dec",
//   ],
//   days: [
//     "Sunday",
//     "Monday",
//     "Tuesday",
//     "Wednesday",
//     "Thursday",
//     "Friday",
//     "Saturday",
//   ],
//   shortDays: ["S", "M", "T", "W", "T", "F", "S"],
//   goToToday: "Go to today",
//   weekNumberFormatString: "Week number {0}",
//   prevMonthAriaLabel: "Previous month",
//   nextMonthAriaLabel: "Next month",
//   prevYearAriaLabel: "Previous year",
//   nextYearAriaLabel: "Next year",
//   prevYearRangeAriaLabel: "Previous year range",
//   nextYearRangeAriaLabel: "Next year range",
//   closeButtonAriaLabel: "Close",
//   monthPickerHeaderAriaLabel: "{0}, select to change the year",
//   yearPickerHeaderAriaLabel: "{0}, select to change the month",
// };

const PduPowerTable: React.FC<PduPowerTableProps> = ({ customerName }) => {
  //custom hooks
  const params: any = useParams();
  const { showToast } = React.useContext(ToastContext);

  const tokenData = parseJwt();

  //state
  const [state, setState] = React.useState({
    isLoading: false,
    date: new Date(),
    showCallender: false,
    datacenters: [],
    datacenterDropdown: [],
    searchObj: {
      customerId: params.customerId,
      startDate: new Date(),
      endDate: new Date(),
      datacenterId: "",
      searchFromLogs: false
    },
    isRackwiseTableOpen: true,
    isDedicatedTableOpen: true,
    rackwiseData: [],
    dedicatedData: [],
    isOnEdit: false,
    remarksObj: {
      customerId: params.customerId,
      datacenterId: "",
      floorId: "",
      remark: "",
      date: new Date(),
    },
    dataObj: {
      serviceId: "",
      minimumCommittedPower: undefined,
    },
    indexRd: undefined,
    isRackwiseDataOnEdit: false,
    rackwiseDataObj: {
      date: new Date(),
      breakerId: [],
      customerRackId: "",
      pduId: [],
      rackId: "",
      kw: undefined,
      amps: undefined,
      kwh: undefined,
      kva: undefined,
    },
    indexDd: undefined,
    isDedicatedDataOnEdit: false,
    dedicatedDataObj: {
      pduId: "",
      date: new Date(),
      firstReading: undefined,
      lastReading: undefined,
      kva: undefined,
      // kwh: undefined,
      kw: undefined,
    },
    powerReportConfig: [],
    reportConfigForDc: {
      customerId: params.customerId,
      datacenterId: "",
      dedicated: [],
      rackwise: [],
      groupByPdu: "floor-wise",
      groupByTempRh: "quadrant-wise",
      hideRackWiseReport: false,
      hideDedicatedReport: false,
    },
    customerRatedDict: {},
    isViewReportDialogOpen: false
  } as {
    isLoading: boolean;
    date: Date;
    showCallender: boolean;
    datacenters: any;
    datacenterDropdown: IDropdownOption[];
    searchObj: ISearchTransactions;
    isRackwiseTableOpen: boolean;
    isDedicatedTableOpen: boolean;
    rackwiseData: any;
    dedicatedData: any;
    isOnEdit: boolean;
    remarksObj: IDedicatedPduRemarks;
    dataObj: {
      serviceId: string;
      minimumCommittedPower?: number;
    };
    indexRd: number | undefined;
    isRackwiseDataOnEdit: boolean;
    rackwiseDataObj: {
      date: Date;
      breakerId: string[];
      customerRackId: string;
      pduId: string[];
      rackId: string;
      amps: number | undefined;
      kw: number | undefined;
      kwh: number | undefined;
      kva: number | undefined;
    };
    indexDd: number | undefined;
    isDedicatedDataOnEdit: boolean;
    dedicatedDataObj: {
      pduId: string;
      date: Date;
      firstReading: number | undefined;
      lastReading: number | undefined;
      // kwh: number | undefined;
      kva: number | undefined;
      kw: number | undefined;
    };
    powerReportConfig: IPowerReportConfigurations[];
    reportConfigForDc: IPowerReportConfigurations;
    customerRatedDict: { [key: string]: boolean };
    isViewReportDialogOpen: boolean;
  });

  React.useEffect(() => {
    const asyncFunc = async () => {
      await getAllDatacenter();
    };
    asyncFunc();
  }, []);

  const getAllDatacenter = async () => {
    setState({ ...state, isLoading: true });
    let result = await getDatacentersForACustomer({
      customerId: params.customerId,
    });
    if (result?.success) {
      let datacenterDropdown: IDropdownOption[] = [];

      result.data?.forEach((item) => {
        datacenterDropdown.push({
          key: item._id as string,
          text: item.name,
        });
      });

      let obj = {
        ...state,
        datacenters: result.data,
        datacenterDropdown,
        searchObj: {
          ...state.searchObj,
          customerId: params.customerId,
          startDate: new Date(),
          endDate: new Date(),
          datacenterId: result.data[0]?._id,
        },
      };
      setState(obj);
      // getPduPowerReport(obj);
      getPowerReportConfig(obj);
    } else {
      setState({ ...state, isLoading: false });
      showToast(result.message || "Error while getting datacenters", "error");
    }
  };

  const getPowerReportConfig = async (paramState: any) => {
    let localState = { ...state };

    if (paramState != null) {
      localState = { ...paramState };
    }
    setState({ ...localState, isLoading: true });
    let result = await getPowerReportConfigurations({
      customerId: params.customerId,
    });
    if (result?.success) {
      let powerReportConfig: IPowerReportConfigurations[] = [];

      localState.datacenters.forEach((datacenter: IDataCenter) => {
        let item = result.data.find((i) => i.datacenterId === datacenter._id);
        if (item) {
          // item["datacenterName"] = datacenter.name;
          powerReportConfig.push(item);
        } else {
          powerReportConfig.push({
            datacenterId: datacenter._id as string,
            // datacenterName: datacenter.name,
            customerId: params.customerId,
            dedicated: ["kwh"],
            rackwise: ["amps", "kw"],
            groupByPdu: "floor-wise",
            groupByTempRh: "quadrant-wise",
            hideDedicatedReport: false,
            hideRackWiseReport: false,
          });
        }
      });
      let obj = {
        ...localState,
        powerReportConfig,
        isLoading: false,
      };
      setState(obj);
      getCustomerRackRatedDetails(obj);
      // getPduPowerReport(obj);
    } else {
      setState({ ...state, isLoading: false });
      showToast(
        result.message || "Error while getting minimum committed power",
        "error"
      );
    }
  };

  const getCustomerRackRatedDetails = async (paramState: any) => {
    let localState = { ...state };

    if (paramState != null) {
      localState = { ...paramState };
    }
    setState({ ...localState, isLoading: true });
    let result = await getCustomerRatedDetailsByDC({
      customerId: params.customerId,
    });
    if (result?.success) {
      let obj = {
        ...localState,
        customerRatedDict: result.data,
        isLoading: false,
      };
      setState(obj);
      getPduPowerReport(obj);
    } else {
      setState({ ...state, isLoading: false });
      showToast(
        result.message || "Error while getting customer rack rated details",
        "error"
      );
    }
  }

  const getPduPowerReport = async (paramState?: any) => {
    let localState = { ...state };

    if (paramState != null) {
      localState = { ...paramState };
    }

    setState({ ...localState, isLoading: true });

    let tempSearch = { ...localState.searchObj };

    tempSearch.startDate = moment(tempSearch.startDate)
      .startOf("month")
      .format("YYYY-MM-DD");
    // .toDate();

    if (!state.searchObj.searchFromLogs) {
      tempSearch.endDate = moment(tempSearch.endDate)
        .endOf("month")
        .format("YYYY-MM-DD");
      // .toDate();
    } else {
      tempSearch.endDate = moment(tempSearch.endDate).format("YYYY-MM-DD HH:mm:ss");
    }

    let result = await getCustomerPowerPduReport(tempSearch);

    if (result?.success) {
      let rackwiseData: any = [];
      let dedicatedData: any = [];

      if (result.data.floors !== undefined) {
        let totalConsumption = 0,
          dedicatedTotalKw = 0,
          dedicatedTotalKva = 0,
          ampsTotal = 0,
          kwTotal = 0,
          kwhTotal = 0,
          kvaTotal = 0;
        totalFloor = Object.keys(result.data.floors).length;

        rackwiseData = Object.keys(result.data.floors).reduce(
          (acc: any, floorItem) => {
            const floor = result.data.floors[floorItem];

            floor.dedicatedData.forEach((pdu: any, i: number) => {
              totalConsumption +=
                (pdu?.lastReading || 0) - (pdu?.firstReading || 0);
              dedicatedTotalKw += (pdu?.kw || 0);
              dedicatedTotalKva += (pdu?.kva || 0);
              dedicatedData.push({
                ...pdu,
                floorName: floor.floor.floorName,
                floorId: floor.floor.floorId,
                floorRowSpan: i === 0 ? floor.dedicatedData.length : 0,
                totalConsumption: totalConsumption,
                remarks: floor.remarks,
                dedicatedTotalKw: dedicatedTotalKw,
                dedicatedTotalKva: dedicatedTotalKva,
                // pduRowSpan:
              });
            });

            acc.push({
              ...floor.floor,
              type: "floor",
              // colSpan: dedicatedData.length > 0 ? 9 : 8,
              // colSpan: dedicatedData.length > 0 ? 8 : 7,
              colSpan: 10,
            });
            Object.keys(floor.rackWiseData).forEach((pduId) => {
              const pdu = floor.rackWiseData[pduId];
              pdu.forEach((pduItem: any, i: number) => {
                ampsTotal += pduItem?.amps || 0;
                kwTotal += pduItem?.kw || 0;
                kwhTotal += pduItem?.kwh || 0;
                kvaTotal += ((pduItem?.amps * 230) / 1000) || 0;

                acc.push({
                  ...pduItem,
                  type: "readings",
                  rowSpan: i === 0 ? pdu.length : 0,
                  ampsTotal: ampsTotal,
                  kwTotal: kwTotal,
                  kwhTotal: kwhTotal,
                  kvaTotal: kvaTotal,
                });
              });
            });
            // let totalConsumption = 0;
            // floor.dedicatedData.forEach((pdu: any, i: number) => {
            //   totalConsumption +=
            //     (pdu?.lastReading || 0) - (pdu?.firstReading || 0);
            //   dedicatedData.push({
            //     ...pdu,
            //     floorName: floor.floor.floorName,
            //     floorId: floor.floor.floorId,
            //     floorRowSpan: i === 0 ? floor.dedicatedData.length : 0,
            //     totalConsumption: totalConsumption,
            //     remarks: floor.remarks,
            //     // pduRowSpan:
            //   });
            // });
            return acc;
          },
          []
        );
        ampsTotalValue = ampsTotal;
        kwhTotalValue = kwhTotal;
        kwTotalValue = kwTotal;
        kvaTotalValue = kvaTotal;
      }

      // console.log("r", rackwiseData);

      // dedicatedData = Object.keys(result.data.floors).reduce(
      //   (acc: any, floorItem) => {
      //     const floor = result.data.floors[floorItem];
      //     let totalConsumption = 0;
      //     floor.dedicatedData.forEach((pdu: any, i: number) => {
      //       totalConsumption +=
      //         (pdu?.lastReading || 0) - (pdu?.firstReading || 0);
      //       acc.push({
      //         ...pdu,
      //         floorName: floor.floor.floorName,
      //         floorId: floor.floor.floorId,
      //         floorRowSpan: i === 0 ? floor.dedicatedData.length : 0,
      //         totalConsumption: totalConsumption,
      //         remarks: floor.remarks,
      //         // pduRowSpan:
      //       });
      //     });
      //     return acc;
      //   },
      //   []
      // );

      // console.log("d", dedicatedData);

      const reportConfigForDc = localState.powerReportConfig.find(
        (i) => i.datacenterId === localState.searchObj.datacenterId
      );

      setState({
        ...localState,
        // searchObj: tempSearch,
        rackwiseData,
        dedicatedData,
        dataObj: {
          serviceId: result.data.serviceId,
          minimumCommittedPower: result.data.minimumCommittedPower.committedKwh,
        },
        indexRd: undefined,
        indexDd: undefined,
        isDedicatedDataOnEdit: false,
        isRackwiseDataOnEdit: false,
        isLoading: false,
        reportConfigForDc:
          (reportConfigForDc as IPowerReportConfigurations) || {},
      });
    } else {
      setState({ ...state, isLoading: false });
      showToast(
        result.message || "Error while getting rackwise power report",
        "error"
      );
    }
  };

  const onSearch = async () => {
    if (!state.searchObj.datacenterId) {
      showToast("Please select a datacenter before searching", "error");
    }

    if (!state.date) {
      showToast("Please select a month before searching", "error");
    }

    getPduPowerReport();
  };

  const handleReportDialogOpenClose = (isOpen: boolean) => {
    setState({ ...state, isViewReportDialogOpen: isOpen });
  }

  const expandOrCollapse = (isDedicated: boolean) => {
    if (isDedicated) {
      setState({
        ...state,
        isDedicatedTableOpen: !state.isDedicatedTableOpen,
      });
    } else {
      setState({
        ...state,
        isRackwiseTableOpen: !state.isRackwiseTableOpen,
      });
    }
  };

  const onSubmitRemarks = async (remark: string, index: number, ele: any) => {
    setState({ ...state, isLoading: true });
    let result = await updateCustomerDedicatedPduRemarks({
      customerId: params.customerId,
      datacenterId: state.searchObj.datacenterId as string,
      remark: remark,
      floorId: ele.floorId,
      date: state.date,
    });
    if (result?.success) {
      let dedicatedData = [...state.dedicatedData];
      if (index !== undefined) {
        dedicatedData[index].remarks = remark;
      }
      setState({ ...state, dedicatedData, isLoading: false, isOnEdit: false });
      showToast("Remarks updated successfully", "success");
    } else {
      setState({ ...state, isLoading: false, isOnEdit: false });
      showToast(result.message || "Error while updating remarks", "error");
    }
  };

  const onLoadRemarks = (remark: string) => {
    let remarksObj = { ...state.remarksObj };
    remarksObj.remark = remark;
    setState({
      ...state,
      remarksObj,
      isOnEdit: true,
    });
  };

  const closeCallender = (ev?: any) => {
    setState({
      ...state,
      showCallender: false,
    });
  };

  const downloadPowerReportPdf = async () => {
    let endDate = moment(state.searchObj.endDate).endOf("month").format("YYYY-MM-DD");
    if (state.searchObj.searchFromLogs) {
      endDate = moment(state.searchObj.endDate).format("YYYY-MM-DD HH:mm:ss");
    }
    let result = await fetch(
      `${API_URL}power-readings/report?customerId=${state.searchObj.customerId
      }&startDate=${moment(state.searchObj.startDate)
        .startOf("month")
        .format("YYYY-MM-DD")}&endDate=${endDate}&datacenterId=${state.searchObj.datacenterId}&searchFromLogs=${state.searchObj.searchFromLogs}`,
      {
        method: "GET",
        credentials: 'include', // Enable credentials for CORS
        headers: {
          at: getToken(),
        },
      }
    );
    let pdf = await result.blob();
    const pdfFile = await new Blob([pdf], { type: "application/pdf" });
    const pdfFileURL = await URL.createObjectURL(pdfFile);
    var a: any = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display:none";
    a.href = pdfFileURL;
    a.download = `${customerName} Monthly Power Report.pdf`;
    a.click();
  };

  const handleRackwiseDataChange = (e: any) => {
    setState({
      ...state,
      rackwiseDataObj: {
        ...state.rackwiseDataObj,
        [e.target.name]: e.target.value,
      },
    });
  };

  const onUpdateRackwiseData = async () => {
    // console.log("rObj", state.rackwiseDataObj);
    let rackwiseDataObj = { ...state.rackwiseDataObj };
    rackwiseDataObj.amps = Number(rackwiseDataObj.amps);
    rackwiseDataObj.kw = Number(rackwiseDataObj.kw);
    rackwiseDataObj.kwh = Number(rackwiseDataObj.kwh);
    rackwiseDataObj.kva = Number(rackwiseDataObj.kva);

    // if (!state.rackwiseDataObj.amps) {
    //   showToast("Source(amps) field is required", "error");
    // } else if (!state.rackwiseDataObj.kw) {
    //   showToast("KW field is required", "error");
    // } else if (state.dedicatedData.length > 0 && !state.rackwiseDataObj.kwh) {
    //   showToast("KWH field is required", "error");
    // } else if (!state.rackwiseDataObj.kva) {
    //   showToast("KVA field is required", "error");
    // } else {
    if (!state.rackwiseDataObj.amps) {
      rackwiseDataObj.amps = 0;
    }
    if (!state.rackwiseDataObj.kw) {
      rackwiseDataObj.kw = 0;
    }
    if (!state.rackwiseDataObj.kwh) {
      rackwiseDataObj.kwh = 0;
    }
    if (!state.rackwiseDataObj.kva) {
      rackwiseDataObj.kva = 0;
    }

    const noOfPdu = rackwiseDataObj.pduId.length;
    if (rackwiseDataObj.pduId.length > 0) {
      rackwiseDataObj.amps = rackwiseDataObj.amps / noOfPdu;
      rackwiseDataObj.kw = rackwiseDataObj.kw / noOfPdu;
      rackwiseDataObj.kwh = rackwiseDataObj.kwh / noOfPdu;
      rackwiseDataObj.kva = rackwiseDataObj.kva / noOfPdu;
    }

    setState({ ...state, isLoading: true });
    rackwiseDataObj.date = state.date;
    let result = await updateCustomerRackwisePdu(rackwiseDataObj);
    if (result?.success) {
      let rackwiseData = [...state.rackwiseData];
      if (state.indexRd !== undefined) {
        rackwiseData[state.indexRd].amps = result.data?.amps * noOfPdu || 0;
        rackwiseData[state.indexRd].kw = result.data?.kw * noOfPdu || 0;
        rackwiseData[state.indexRd].kwh = result.data?.kwh * noOfPdu || 0;
        rackwiseData[state.indexRd].kva = result.data?.kva * noOfPdu || 0;
      }
      setState({
        ...state,
        rackwiseData,
        indexRd: undefined,
        isRackwiseDataOnEdit: false,
        rackwiseDataObj: {
          date: new Date(),
          breakerId: [],
          customerRackId: "",
          pduId: [],
          rackId: "",
          kw: undefined,
          amps: undefined,
          kwh: undefined,
          kva: undefined,
        },
        isLoading: false,
      });
      showToast("Rackwise Pdu updated successfully", "success");
    } else {
      setState({ ...state, isLoading: false });
      showToast(
        result?.message || "Error while updating rackwise pdu values",
        "error"
      );
    }
    // }
  };

  const handleDedicatedDataChange = (e: any) => {
    setState({
      ...state,
      dedicatedDataObj: {
        ...state.dedicatedDataObj,
        [e.target.name]: e.target.value,
      },
    });
  };

  const onUpdateDedicatedData = async () => {
    // console.log("dObj", state.dedicatedDataObj);
    let dedicatedDataObj = { ...state.dedicatedDataObj };
    dedicatedDataObj.firstReading = Number(dedicatedDataObj.firstReading);
    dedicatedDataObj.lastReading = Number(dedicatedDataObj.lastReading);
    dedicatedDataObj.kw = Number(dedicatedDataObj.kw);
    dedicatedDataObj.kva = Number(dedicatedDataObj.kva);
    // if (
    //   state.reportConfigForDc.dedicated.includes("kwh") &&
    //   !state.dedicatedDataObj.firstReading
    // ) {
    //   // showToast("First Reading field is required", "error");
    //   dedicatedDataObj.firstReading = 0;
    // } else if (
    //   state.reportConfigForDc.dedicated.includes("kwh") &&
    //   !state.dedicatedDataObj.lastReading
    // ) {
    //   // showToast("Last Reading is required", "error");
    //   dedicatedDataObj.lastReading = 0;
    // }
    // //  else if (!state.dedicatedDataObj.kwh) {
    // //   showToast("KWH field is required", "error");
    // // }
    // else if (
    //   state.reportConfigForDc.dedicated.includes("kva") &&
    //   !state.dedicatedDataObj.kva
    // ) {
    //   // showToast("KVA field is required", "error");
    //   dedicatedDataObj.kva = 0;
    // } else if (
    //   state.reportConfigForDc.dedicated.includes("kw") &&
    //   !state.dedicatedDataObj.kw
    // ) {
    //   // showToast("KW field is required", "error");
    //   dedicatedDataObj.kw = 0;
    // } else {
    if (
      state.reportConfigForDc.dedicated.includes("kwh") &&
      !state.dedicatedDataObj.firstReading
    ) {
      dedicatedDataObj.firstReading = 0;
    }
    if (
      state.reportConfigForDc.dedicated.includes("kwh") &&
      !state.dedicatedDataObj.lastReading
    ) {
      dedicatedDataObj.lastReading = 0;
    }
    if (
      state.reportConfigForDc.dedicated.includes("kva") &&
      !state.dedicatedDataObj.kva
    ) {
      dedicatedDataObj.kva = 0;
    }
    if (
      state.reportConfigForDc.dedicated.includes("kw") &&
      !state.dedicatedDataObj.kw
    ) {
      dedicatedDataObj.kw = 0;
    }

    setState({ ...state, isLoading: true });
    let result = await updateCustomerDedicatedPdu(dedicatedDataObj);
    if (result?.success) {
      let dedicatedData = [...state.dedicatedData];
      if (state.indexDd !== undefined) {
        dedicatedData[state.indexDd].firstReading =
          result.data?.firstReading || 0;
        dedicatedData[state.indexDd].lastReading =
          result.data?.lastReading || 0;
        // dedicatedData[state.indexDd].kwh = result.data?.kwh || 0;
        dedicatedData[state.indexDd].kva = result.data?.kva || 0;
        dedicatedData[state.indexDd].kw = result.data?.kw || 0;
      }
      setState({
        ...state,
        dedicatedData,
        indexDd: undefined,
        isDedicatedDataOnEdit: false,
        dedicatedDataObj: {
          ...state.dedicatedDataObj,
          pduId: "",
          firstReading: undefined,
          lastReading: undefined,
          // kwh: undefined,
          kva: undefined,
          kw: undefined,
        },
        isLoading: false,
      });
      showToast("Dedicated Pdu updated successfully", "success");
    } else {
      setState({ ...state, isLoading: false });
      showToast(
        result?.message || "Error while updating dedicated pdu values",
        "error"
      );
    }
    // }
  };

  let grandTotalConsumption: number = 0;

  const getTotalConsumption = (firstReading: number, lastReading: number) => {
    let totalConsumption = lastReading - firstReading;
    grandTotalConsumption += totalConsumption;
    return toFixedValue(totalConsumption);
  };

  let sNo = 1;

  return (
    <React.Fragment>
      {state.isLoading && <Loading />}
      <Stack>
        <Stack.Item>
          <Stack
            horizontal
            wrap
            tokens={childrenGap}
            horizontalAlign="space-between"
            className="pt-16"
          >
            <Stack.Item>
              <Stack tokens={childrenGap8} horizontalAlign="start">
                <Stack.Item>
                  <Stack tokens={childrenGap} horizontal verticalAlign="center" wrap
                  //  horizontalAlign="start"
                  >
                    <Stack.Item>
                      <Dropdown
                        placeholder="Select a datacenter"
                        selectedKey={state.searchObj.datacenterId}
                        // defaultSelectedKey={state.searchObj.datacenterId}
                        styles={{ dropdown: { width: 200 } }}
                        options={state.datacenterDropdown}
                        onChange={(e, v: IDropdownOption | undefined) => {
                          if (v) {
                            setState({
                              ...state,
                              searchObj: {
                                ...state.searchObj,
                                datacenterId: v.key as string,
                              },
                            });
                            // console.log("v", v.key);
                          }
                        }}
                      />
                    </Stack.Item>
                    {!state.searchObj.searchFromLogs ? (
                      <Stack.Item>
                        {/* <DatePicker
                    firstDayOfWeek={DayOfWeek.Sunday}
                    value={state.date}
                    showGoToToday={false}
                    showMonthPickerAsOverlay={true}
                    onSelectDate={(date: Date | null | undefined) =>
                      setState({
                        ...state,
                        date: date as any,
                        searchObj: {
                          ...state.searchObj,
                          startDate: moment(date).startOf("month").toDate(),
                          endDate: moment(date).endOf("month").toDate(),
                        },
                      })
                    }
                    placeholder="Select a date..."
                    ariaLabel="Select a date"
                  /> */}
                        <div
                          ref={(calendarBtn) =>
                            (calendarButtonElement = calendarBtn!)
                          }
                        >
                          <DefaultButton
                            text={
                              !state.date
                                ? "Select a month"
                                : moment(state.date).format("MMM-YYYY")
                            }
                            onClick={() =>
                              setState({ ...state, showCallender: true })
                            }
                            className="month-picker-btn"
                          />
                        </div>
                        {state.showCallender && (
                          <Callout
                            isBeakVisible={false}
                            // className="ms-DatePicker-callout"
                            gapSpace={0}
                            doNotLayer={false}
                            target={calendarButtonElement}
                            directionalHint={DirectionalHint.bottomLeftEdge}
                            onDismiss={() => closeCallender()}
                            setInitialFocus
                          >
                            <FocusTrapZone
                              firstFocusableSelector="ms-DatePicker-day--today"
                              isClickableOutsideFocusTrap
                            >
                              <Calendar
                                // eslint-disable-next-line react/jsx-no-bind
                                onSelectDate={(date: Date | null | undefined) =>
                                  setState({
                                    ...state,
                                    date: date as any,
                                    searchObj: {
                                      ...state.searchObj,
                                      startDate: moment(date)
                                        .startOf("month")
                                        .toDate(),
                                      endDate: moment(date).endOf("month").toDate(),
                                    },
                                    showCallender: false,
                                  })
                                }
                                onDismiss={() => closeCallender()}
                                isMonthPickerVisible={true}
                                value={state.date}
                                firstDayOfWeek={DayOfWeek.Sunday}
                                strings={DayPickerStrings}
                                isDayPickerVisible={false}
                                highlightCurrentMonth={false}
                                highlightSelectedMonth={true}
                                showMonthPickerAsOverlay={false}
                                showGoToToday={false}
                              />
                            </FocusTrapZone>
                          </Callout>
                        )}
                      </Stack.Item>
                    ) : (
                      <Stack.Item className="custom-datepicker">
                        <Datetime
                          className="custom-field-group ms-TextField-fieldGroup height-32"
                          inputProps={{
                            className: "ms-TextField-field px-8 border-0 w-100",
                          }}
                          dateFormat="ddd MMM DD YYYY"
                          timeFormat="HH:mm"
                          value={state.date}
                          onChange={(date) => {
                            setState({
                              ...state,
                              date: moment(date).toDate(),
                              searchObj: {
                                ...state.searchObj,
                                startDate: moment(date)
                                  .startOf("month")
                                  .toDate(),
                                endDate: moment(date).toDate(),
                              },
                            })
                          }}
                        />
                      </Stack.Item>
                    )}
                    <Stack.Item>
                      <PrimaryButton text="Search" onClick={() => onSearch()} />
                    </Stack.Item>
                    <Stack.Item>
                      <Checkbox
                        label="Show Date/Time Picker"
                        checked={state.searchObj.searchFromLogs}
                        onChange={(e, v) => {
                          setState({ ...state, searchObj: { ...state.searchObj, searchFromLogs: v } });
                        }}
                      />
                    </Stack.Item>
                  </Stack>
                </Stack.Item>
                {state.searchObj.searchFromLogs && (
                  <Stack.Item>
                    <Text className="error-msg color-danger">*Depending upon the load on database that will be accessed, it may take about 10 minutes to give result of your query</Text>
                  </Stack.Item>
                )}
              </Stack>
            </Stack.Item>
            <Stack.Item>
              <Stack horizontal tokens={childrenGap} horizontalAlign="end">
                {state.searchObj.datacenterId && state.customerRatedDict[state.searchObj.datacenterId] && (
                  <Stack.Item>
                    <PrimaryButton
                      text="Upload Power Report"
                      onClick={() => handleReportDialogOpenClose(true)}
                    />
                  </Stack.Item>
                )}
                <Stack.Item>
                  <DefaultButton
                    text="Download Report"
                    onClick={() => downloadPowerReportPdf()}
                    className="custom-secondary-btn"
                    disabled={
                      state.isLoading ||
                      (state.rackwiseData.length === 0 &&
                        state.dedicatedData.length === 0)
                    }
                  />
                </Stack.Item>
              </Stack>
            </Stack.Item>
          </Stack>
        </Stack.Item>
        <br />
        {state.datacenters && state.datacenters.length > 0 ? (
          <React.Fragment>
            {state.dedicatedData.length > 0 && (
              <React.Fragment>
                <Stack.Item>
                  <Label>
                    Service ID:{" "}
                    <span style={{ color: "#135c8a", paddingRight: 40 }}>
                      {state.dataObj.serviceId}
                    </span>
                    Minimum Committed(KWH):{" "}
                    <span style={{ color: "#135c8a" }}>
                      {state.dataObj.minimumCommittedPower}
                    </span>
                  </Label>
                </Stack.Item>
                <br />
                {![2, 4, 5].includes(tokenData.role) && (
                  <Stack.Item align="end">
                    <Toggle
                      checked={!state.reportConfigForDc.hideDedicatedReport}
                      onText="Disable Dedicated Table"
                      offText="Enable Dedicated Table"
                      onChange={async (e, v) => {
                        let reportConfigForDc = { ...state.reportConfigForDc };
                        reportConfigForDc.hideDedicatedReport = !v as boolean;
                        setState({ ...state, isLoading: true });
                        const result = await updatePowerReportConfigurations(
                          reportConfigForDc
                        );
                        if (result?.success) {
                          let powerReportConfig = [...state.powerReportConfig];
                          const index = powerReportConfig.findIndex(
                            (i) => i.datacenterId === result.data.datacenterId
                          );
                          if (index !== -1) {
                            powerReportConfig[index] = result.data;
                          }
                          setState({
                            ...state,
                            reportConfigForDc: result.data,
                            isDedicatedTableOpen: v as boolean,
                            powerReportConfig,
                            isLoading: false,
                          });
                        } else {
                          setState({ ...state, isLoading: false });
                          showToast(
                            result.message ||
                            "Error while updating report config",
                            "error"
                          );
                        }
                      }}
                    />
                  </Stack.Item>
                )}
                <br />
                <Stack.Item>
                  <Stack
                    horizontal
                    horizontalAlign="space-between"
                    className="pointer"
                    style={{
                      backgroundColor: "#c7e0f4",
                      alignItems: "center",
                      paddingLeft: 5,
                      paddingRight: 5,
                      paddingTop: 7,
                      paddingBottom: 7,
                    }}
                    onClick={() => expandOrCollapse(true)}
                  >
                    <Stack.Item>
                      <Label style={{ color: "#135c8a" }}>
                        Dedicated Table
                      </Label>
                    </Stack.Item>
                    <Stack.Item>
                      <span>
                        <Icon
                          path={
                            state.isDedicatedTableOpen
                              ? mdiChevronDown
                              : mdiChevronRight
                          }
                          size={0.8}
                          className="pointer"
                          color={THEME.palette.neutralPrimary}
                        />
                      </span>
                    </Stack.Item>
                  </Stack>
                </Stack.Item>
                <Stack.Item>
                  <Formik
                    enableReinitialize
                    initialValues={state.remarksObj}
                    onSubmit={async (
                      values: IDedicatedPduRemarks,
                      { setSubmitting }
                    ) => {
                      setSubmitting(false);
                    }}
                  >
                    {({ handleSubmit, values }) => (
                      <form onSubmit={handleSubmit}>
                        {!state.reportConfigForDc.hideDedicatedReport &&
                          state.isDedicatedTableOpen && (
                            <Stack>
                              <div className="office-table bg-white">
                                <table className="ms-Table bordered-table w-100">
                                  <thead className="html-table-thead">
                                    <tr>
                                      <th rowSpan={2}>Floor</th>
                                      {/* <th>Customer Rack ID</th> */}
                                      {/* <th>Power Source</th> */}
                                      <th rowSpan={2}>PDU/DB Details</th>
                                      <th rowSpan={2}>
                                        No. of Racks connected
                                      </th>
                                      {/* <th colSpan={3}>Source</th> */}
                                      {state.reportConfigForDc?.dedicated?.includes(
                                        "kwh"
                                      ) && <th colSpan={3}>Source</th>}
                                      {state.reportConfigForDc?.dedicated?.includes(
                                        "kva"
                                      ) && <th rowSpan={2}>KVA</th>}
                                      {state.reportConfigForDc?.dedicated?.includes(
                                        "kw"
                                      ) && <th rowSpan={2}>KW</th>}
                                      {![2, 4, 5].includes(tokenData.role) && (
                                        <th rowSpan={2}>Actions</th>
                                      )}
                                      <th rowSpan={2}>Remarks</th>
                                    </tr>
                                    {state.reportConfigForDc?.dedicated?.includes(
                                      "kwh"
                                    ) && (
                                        <tr>
                                          <th>First Reading</th>
                                          <th>Last Reading</th>
                                          <th>Total Consumption</th>
                                          {/* <th>First Reading</th>
                                       <th>Last Reading</th> */}
                                        </tr>
                                      )}
                                  </thead>
                                  <tbody>
                                    {
                                      state.dedicatedData.map(
                                        (ele: any, index: number) => {
                                          // debugger;
                                          return (
                                            <>
                                              <tr key={index}>
                                                {ele?.floorRowSpan !== 0 && (
                                                  <td
                                                    rowSpan={ele?.floorRowSpan}
                                                  >
                                                    {ele?.floorName || ""}
                                                  </td>
                                                )}
                                                <td>{ele?.pduName || ""}</td>
                                                <td width={120} align="right">
                                                  {ele?.rackCount || 0}
                                                </td>
                                                {state.isDedicatedDataOnEdit &&
                                                  state.indexDd === index
                                                  ? state.reportConfigForDc?.dedicated?.includes(
                                                    "kwh"
                                                  ) && (
                                                    <td width={180}>
                                                      <TextField
                                                        value={String(
                                                          state
                                                            .dedicatedDataObj
                                                            .firstReading
                                                        )}
                                                        type="number"
                                                        name="firstReading"
                                                        onChange={
                                                          handleDedicatedDataChange
                                                        }
                                                      // className="width-100"
                                                      />
                                                    </td>
                                                  )
                                                  : state.reportConfigForDc?.dedicated?.includes(
                                                    "kwh"
                                                  ) && (
                                                    <td align="right">
                                                      {/* {ele?.firstReading || 0} */}
                                                      {toFixedValue(
                                                        ele?.firstReading
                                                      )}
                                                    </td>
                                                  )}
                                                {state.isDedicatedDataOnEdit &&
                                                  state.indexDd === index
                                                  ? state.reportConfigForDc?.dedicated?.includes(
                                                    "kwh"
                                                  ) && (
                                                    <td width={180}>
                                                      <TextField
                                                        value={String(
                                                          state
                                                            .dedicatedDataObj
                                                            .lastReading
                                                        )}
                                                        type="number"
                                                        name="lastReading"
                                                        onChange={
                                                          handleDedicatedDataChange
                                                        }
                                                      // className="width-100"
                                                      />
                                                    </td>
                                                  )
                                                  : state.reportConfigForDc?.dedicated?.includes(
                                                    "kwh"
                                                  ) && (
                                                    <td align="right">
                                                      {/* {ele?.lastReading || 0} */}
                                                      {toFixedValue(
                                                        ele?.lastReading
                                                      )}
                                                    </td>
                                                  )}
                                                {state.reportConfigForDc?.dedicated?.includes(
                                                  "kwh"
                                                ) && (
                                                    <td width={190} align="right">
                                                      {getTotalConsumption(
                                                        ele?.firstReading,
                                                        ele?.lastReading
                                                      )}
                                                    </td>
                                                  )}
                                                {/* {state.isDedicatedDataOnEdit &&
                                              state.indexDd === index
                                                ? state.reportConfigForDc?.dedicated?.includes(
                                                    "kwh"
                                                  ) && (
                                                    <td width={180}>
                                                      <TextField
                                                        value={String(
                                                          state.dedicatedDataObj
                                                            .kwh
                                                        )}
                                                        type="number"
                                                        name="kwh"
                                                        onChange={
                                                          handleDedicatedDataChange
                                                        }
                                                      />
                                                    </td>
                                                  )
                                                : state.reportConfigForDc?.dedicated?.includes(
                                                    "kwh"
                                                  ) && (
                                                    <td align="right">
                                                      {toFixedValue(
                                                        ele?.kwh || 0
                                                      )}
                                                    </td>
                                                  )} */}
                                                {state.isDedicatedDataOnEdit &&
                                                  state.indexDd === index
                                                  ? state.reportConfigForDc?.dedicated?.includes(
                                                    "kva"
                                                  ) && (
                                                    <td width={180}>
                                                      <TextField
                                                        value={String(
                                                          state
                                                            .dedicatedDataObj
                                                            .kva
                                                        )}
                                                        type="number"
                                                        name="kva"
                                                        onChange={
                                                          handleDedicatedDataChange
                                                        }
                                                      // className="width-100"
                                                      />
                                                    </td>
                                                  )
                                                  : state.reportConfigForDc?.dedicated?.includes(
                                                    "kva"
                                                  ) && (
                                                    <td align="right">
                                                      {/* {ele?.kva || 0} */}
                                                      {toFixedValue(
                                                        ele?.kva || 0
                                                      )}
                                                    </td>
                                                  )}
                                                {state.isDedicatedDataOnEdit &&
                                                  state.indexDd === index
                                                  ? state.reportConfigForDc?.dedicated?.includes(
                                                    "kw"
                                                  ) && (
                                                    <td width={180}>
                                                      <TextField
                                                        value={String(
                                                          state
                                                            .dedicatedDataObj
                                                            .kw
                                                        )}
                                                        type="number"
                                                        name="kw"
                                                        onChange={
                                                          handleDedicatedDataChange
                                                        }
                                                      // className="width-100"
                                                      />
                                                    </td>
                                                  )
                                                  : state.reportConfigForDc?.dedicated?.includes(
                                                    "kw"
                                                  ) && (
                                                    <td align="right">
                                                      {/* {ele?.kw || 0} */}
                                                      {toFixedValue(
                                                        ele?.kw || 0
                                                      )}
                                                    </td>
                                                  )}
                                                {![2, 4, 5].includes(tokenData.role) && (
                                                  <td align="center">
                                                    {state.isDedicatedDataOnEdit &&
                                                      state.indexDd === index ? (
                                                      <React.Fragment>
                                                        <TooltipHost
                                                          content="Save"
                                                          calloutProps={{
                                                            gapSpace: 0,
                                                          }}
                                                        >
                                                          <span
                                                            onClick={() =>
                                                              onUpdateDedicatedData()
                                                            }
                                                          >
                                                            <Icon
                                                              path={mdiCheck}
                                                              size={0.8}
                                                              className="pointer"
                                                              color="green"
                                                            />
                                                          </span>
                                                        </TooltipHost>
                                                        &nbsp;&nbsp;
                                                        <TooltipHost
                                                          content="Cancel"
                                                          calloutProps={{
                                                            gapSpace: 0,
                                                          }}
                                                        >
                                                          <span
                                                            onClick={() =>
                                                              setState({
                                                                ...state,
                                                                isDedicatedDataOnEdit:
                                                                  false,
                                                                indexDd:
                                                                  undefined,
                                                                dedicatedDataObj:
                                                                {
                                                                  firstReading:
                                                                    undefined,
                                                                  lastReading:
                                                                    undefined,
                                                                  pduId: "",
                                                                  date: new Date(),
                                                                  // kwh: undefined,
                                                                  kva: undefined,
                                                                  kw: undefined,
                                                                },
                                                              })
                                                            }
                                                          >
                                                            <Icon
                                                              path={mdiClose}
                                                              size={0.8}
                                                              className="pointer"
                                                              color="red"
                                                            />
                                                          </span>
                                                        </TooltipHost>
                                                      </React.Fragment>
                                                    ) : (
                                                      <React.Fragment>
                                                        <TooltipHost
                                                          content="Edit"
                                                          calloutProps={{
                                                            gapSpace: 0,
                                                          }}
                                                        >
                                                          <span
                                                            onClick={() =>
                                                              setState({
                                                                ...state,
                                                                isDedicatedDataOnEdit:
                                                                  true,
                                                                indexDd: index,
                                                                dedicatedDataObj:
                                                                {
                                                                  // ...state.rackwiseDataObj,
                                                                  firstReading:
                                                                    ele?.firstReading ||
                                                                    0,
                                                                  lastReading:
                                                                    ele?.lastReading ||
                                                                    0,
                                                                  pduId:
                                                                    ele?.pduId ||
                                                                    "",
                                                                  date:
                                                                    ele?.date ||
                                                                    new Date(),
                                                                  // kwh:
                                                                  //   ele?.kwh || 0,
                                                                  kva:
                                                                    ele?.kva ||
                                                                    0,
                                                                  kw:
                                                                    ele?.kw ||
                                                                    0,
                                                                },
                                                              })
                                                            }
                                                          >
                                                            <Icon
                                                              path={mdiPencil}
                                                              size={0.7}
                                                              className="pointer"
                                                              color={
                                                                THEME.palette
                                                                  .themePrimary
                                                              }
                                                            />
                                                          </span>
                                                        </TooltipHost>
                                                      </React.Fragment>
                                                    )}
                                                  </td>
                                                )}
                                                {state.isOnEdit === false &&
                                                  ele?.floorRowSpan !== 0 && (
                                                    <td
                                                      rowSpan={
                                                        ele?.floorRowSpan
                                                      }
                                                      align="center"
                                                      width={170}
                                                    >
                                                      <Stack
                                                        tokens={childrenGap}
                                                      >
                                                        <Stack.Item>
                                                          {ele?.remarks || ""}
                                                        </Stack.Item>
                                                        {![2, 4, 5].includes(tokenData.role) && (
                                                          <Stack.Item>
                                                            <TooltipHost
                                                              content="Edit Remarks"
                                                              calloutProps={{
                                                                gapSpace: 0,
                                                              }}
                                                            >
                                                              <span
                                                                onClick={() =>
                                                                  onLoadRemarks(
                                                                    ele?.remarks
                                                                  )
                                                                }
                                                              >
                                                                <Icon
                                                                  path={
                                                                    mdiPencil
                                                                  }
                                                                  size={0.7}
                                                                  className="pointer"
                                                                  color={
                                                                    THEME
                                                                      .palette
                                                                      .themePrimary
                                                                  }
                                                                />
                                                              </span>
                                                            </TooltipHost>
                                                          </Stack.Item>
                                                        )}
                                                      </Stack>
                                                    </td>
                                                  )}
                                                {state.isOnEdit === true &&
                                                  ele?.floorRowSpan !== 0 && (
                                                    <td
                                                      rowSpan={
                                                        ele?.floorRowSpan
                                                      }
                                                      width={170}
                                                    >
                                                      <Stack>
                                                        <Stack.Item>
                                                          <CustomTextField
                                                            name={"remark"}
                                                          />
                                                        </Stack.Item>
                                                        <br />
                                                        <Stack.Item>
                                                          <Stack
                                                            horizontal
                                                            horizontalAlign="center"
                                                            tokens={childrenGap}
                                                          >
                                                            <Stack.Item>
                                                              <TooltipHost
                                                                content="Cancel"
                                                                calloutProps={{
                                                                  gapSpace: 0,
                                                                }}
                                                              >
                                                                <span
                                                                  onClick={() =>
                                                                    setState({
                                                                      ...state,
                                                                      isOnEdit:
                                                                        false,
                                                                    })
                                                                  }
                                                                >
                                                                  <Icon
                                                                    path={
                                                                      mdiClose
                                                                    }
                                                                    size={0.7}
                                                                    className="pointer"
                                                                    color="red"
                                                                  />
                                                                </span>
                                                              </TooltipHost>
                                                            </Stack.Item>
                                                            <Stack.Item>
                                                              <TooltipHost
                                                                content="Submit"
                                                                calloutProps={{
                                                                  gapSpace: 0,
                                                                }}
                                                              >
                                                                <span
                                                                  onClick={() =>
                                                                    onSubmitRemarks(
                                                                      values.remark,
                                                                      index,
                                                                      ele
                                                                    )
                                                                  }
                                                                >
                                                                  <Icon
                                                                    path={
                                                                      mdiCheck
                                                                    }
                                                                    size={0.7}
                                                                    className="pointer"
                                                                    color="green"
                                                                  />
                                                                </span>
                                                              </TooltipHost>
                                                            </Stack.Item>
                                                          </Stack>
                                                        </Stack.Item>
                                                      </Stack>
                                                    </td>
                                                  )}
                                              </tr>
                                              {state.dedicatedData.length ===
                                                index + 1 &&
                                                state.reportConfigForDc?.dedicated?.includes(
                                                  "kwh"
                                                ) && (
                                                  <tr>
                                                    <th colSpan={5}>Total</th>
                                                    <th align="right">
                                                      {/* {grandTotalConsumption || 0} */}
                                                      {toFixedValue(
                                                        ele?.totalConsumption
                                                      )}
                                                    </th>
                                                    {/* {state.reportConfigForDc?.dedicated?.includes(
                                                    "kwh"
                                                  ) && <th></th>} */}
                                                    {state.reportConfigForDc?.dedicated?.includes(
                                                      "kva"
                                                    ) && <th align="right">{toFixedValue(ele?.dedicatedTotalKva || 0)}</th>}
                                                    {state.reportConfigForDc?.dedicated?.includes(
                                                      "kw"
                                                    ) && <th align="right">{toFixedValue(ele?.dedicatedTotalKw || 0)}
                                                      </th>}
                                                    <th></th>
                                                    {![2, 4, 5].includes(tokenData.role) && (
                                                      <th></th>
                                                    )}
                                                  </tr>
                                                )}
                                            </>
                                          );
                                        }
                                      )
                                      //  : (
                                      //   <tr>
                                      //     <td colSpan={7} align="center">
                                      //       <br />
                                      //       <i>No Data Found</i>
                                      //       <br />
                                      //       <br />
                                      //     </td>
                                      //   </tr>
                                      // )
                                    }
                                  </tbody>
                                </table>
                              </div>
                            </Stack>
                          )}
                      </form>
                    )}
                  </Formik>
                </Stack.Item>
              </React.Fragment>
            )}
            <br />
            <br />
            {![2, 4, 5].includes(tokenData.role) && (
              <Stack.Item align="end">
                <Toggle
                  checked={!state.reportConfigForDc.hideRackWiseReport}
                  onText="Disable Rackwise Table"
                  offText="Enable Rackwise Table"
                  onChange={async (e, v) => {
                    let reportConfigForDc = { ...state.reportConfigForDc };
                    reportConfigForDc.hideRackWiseReport = !v as boolean;
                    setState({ ...state, isLoading: true });
                    const result = await updatePowerReportConfigurations(
                      reportConfigForDc
                    );
                    if (result?.success) {
                      let powerReportConfig = [...state.powerReportConfig];
                      const index = powerReportConfig.findIndex(
                        (i) => i.datacenterId === result.data.datacenterId
                      );
                      if (index !== -1) {
                        powerReportConfig[index] = result.data;
                      }
                      setState({
                        ...state,
                        reportConfigForDc: result.data,
                        isRackwiseTableOpen: v as boolean,
                        powerReportConfig,
                        isLoading: false,
                      });
                    } else {
                      setState({ ...state, isLoading: false });
                      showToast(
                        result.message || "Error while updating report config",
                        "error"
                      );
                    }
                  }}
                />
              </Stack.Item>
            )}
            <br />
            <Stack.Item>
              <Stack
                horizontal
                horizontalAlign="space-between"
                className="pointer"
                style={{
                  backgroundColor: "#c7e0f4",
                  alignItems: "center",
                  paddingLeft: 5,
                  paddingRight: 5,
                  paddingTop: 7,
                  paddingBottom: 7,
                }}
                onClick={() => expandOrCollapse(false)}
              >
                <Stack.Item>
                  <Label style={{ color: "#135c8a" }}>Rack Wise Table</Label>
                </Stack.Item>
                <Stack.Item>
                  <span>
                    <Icon
                      path={
                        state.isRackwiseTableOpen
                          ? mdiChevronDown
                          : mdiChevronRight
                      }
                      size={0.8}
                      className="pointer"
                      color={THEME.palette.neutralPrimary}
                    />
                  </span>
                </Stack.Item>
              </Stack>
            </Stack.Item>
            <Stack.Item>
              {!state.reportConfigForDc.hideRackWiseReport &&
                state.isRackwiseTableOpen && (
                  <Stack>
                    <div className="office-table bg-white">
                      <table className="ms-Table bordered-table w-100">
                        <thead className="html-table-thead">
                          <tr style={{ height: 44 }}>
                            <th rowSpan={2}>S. No</th>
                            <th rowSpan={2}>Customer Rack ID</th>
                            {/* <th rowSpan={2}>Rack ID</th>
                          <th rowSpan={2}>Customer Rack ID</th> */}
                            <th rowSpan={2}>Power Source</th>
                            <th rowSpan={2}>PDU/DB Details</th>
                            <th rowSpan={2}>Single/Three Phase or DC</th>
                            {state.reportConfigForDc?.rackwise?.includes(
                              "amps"
                            ) && <th rowSpan={2}>Source (Amp)</th>}
                            {state.reportConfigForDc?.rackwise?.includes(
                              "kw"
                            ) && <th rowSpan={2}>KW</th>}
                            {/* {state.dedicatedData.length > 0 &&
                            state.reportConfigForDc?.rackwise?.includes(
                              "kwh"
                            ) && <th rowSpan={2}>KWH</th>} */}
                            {state.reportConfigForDc?.rackwise?.includes(
                              "kwh"
                            ) && <th rowSpan={2}>KWH</th>}
                            {state.reportConfigForDc?.rackwise?.includes(
                              "kva"
                            ) && <th rowSpan={2}>KVA</th>}
                            {![2, 4, 5].includes(tokenData.role) && (
                              <th rowSpan={2}>Actions</th>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {state.rackwiseData &&
                            state.rackwiseData.length > 0 ? (
                            state.rackwiseData.map(
                              (ele: any, index: number) => {
                                return (
                                  <>
                                    <tr key={index}>
                                      {ele.type === "floor" && (
                                        <th
                                          colSpan={ele.colSpan}
                                        >{`Below details against tower ${ele.buildingName} ${ele.floorName} floor setup`}</th>
                                      )}
                                      {ele.type === "readings" && (
                                        <>
                                          <td>{sNo++}</td>
                                          {/* <td>
                                      {(ele.type === "readings" &&
                                        ele.rackId) ||
                                        ""}
                                    </td> */}
                                          {ele.rowSpan !== 0 && (
                                            <td rowSpan={ele.rowSpan}>
                                              {(ele.type === "readings" &&
                                                ele.quadrantName +
                                                " - " +
                                                ele.rackId) ||
                                                ""}
                                            </td>
                                          )}
                                          {/* <td>
                                      {(ele.type === "readings" &&
                                        ele.customerRackId) ||
                                        ""}
                                    </td> */}
                                          {/* {ele.rowSpan !== 0 && (
                                      <td rowSpan={ele.rowSpan}>
                                        {(ele.type === "readings" &&
                                          ele.customerRackId) ||
                                          ""}
                                      </td>
                                    )} */}
                                          {/* {ele.rowSpan !== 0 && (
                                      <td rowSpan={ele.rowSpan}>
                                        {(ele.type === "readings" &&
                                          ele.pduName) ||
                                          ""}
                                      </td>
                                    )} */}
                                          {/* {ele.rowSpan !== 0 && (
                                          <td rowSpan={ele.rowSpan}>
                                            {(ele.type === "readings" &&
                                              ele.pduName.join(", ")) ||
                                              ""}
                                          </td>
                                        )} */}
                                          <td>
                                            {(ele.type === "readings" &&
                                              ele.pduName.join(", ")) ||
                                              ""}
                                          </td>
                                          <td>
                                            {(ele.type === "readings" &&
                                              ele.breakerName) ||
                                              ""}
                                          </td>
                                          <td width={200}>
                                            {ele.type === "readings" &&
                                              ele.phase === "3"
                                              ? "Three Phase"
                                              : "Single Phase"}
                                          </td>
                                          {state.isRackwiseDataOnEdit &&
                                            state.indexRd === index
                                            ? state.reportConfigForDc?.rackwise?.includes(
                                              "amps"
                                            ) && (
                                              <td width={140}>
                                                <TextField
                                                  value={String(
                                                    state.rackwiseDataObj.amps
                                                  )}
                                                  type="number"
                                                  name="amps"
                                                  onChange={
                                                    handleRackwiseDataChange
                                                  }
                                                // className="width-100"
                                                />
                                              </td>
                                            )
                                            : state.reportConfigForDc?.rackwise?.includes(
                                              "amps"
                                            ) && (
                                              <td align="right">
                                                {/* {(ele.type === "readings" &&
                                          ele.amps) ||
                                          0} */}
                                                {ele.type === "readings" &&
                                                  toFixedValue(ele.amps)}
                                              </td>
                                            )}
                                          {state.isRackwiseDataOnEdit &&
                                            state.indexRd === index
                                            ? state.reportConfigForDc?.rackwise?.includes(
                                              "kw"
                                            ) && (
                                              <td width={140}>
                                                <TextField
                                                  value={String(
                                                    state.rackwiseDataObj.kw
                                                  )}
                                                  type="number"
                                                  name="kw"
                                                  onChange={
                                                    handleRackwiseDataChange
                                                  }
                                                // className="width-100"
                                                />
                                              </td>
                                            )
                                            : state.reportConfigForDc?.rackwise?.includes(
                                              "kw"
                                            ) && (
                                              <td align="right" width={140}>
                                                {/* {(ele.type === "readings" && ele.kw) ||
                                          0} */}
                                                {ele.type === "readings" &&
                                                  toFixedValue(ele.kw)}
                                              </td>
                                            )}
                                          {state.isRackwiseDataOnEdit &&
                                            state.indexRd === index
                                            ? state.reportConfigForDc?.rackwise?.includes(
                                              "kwh"
                                            ) && (
                                              <td width={140}>
                                                <TextField
                                                  value={String(
                                                    state.rackwiseDataObj.kwh
                                                  )}
                                                  type="number"
                                                  name="kwh"
                                                  onChange={
                                                    handleRackwiseDataChange
                                                  }
                                                // className="width-100"
                                                />
                                              </td>
                                            )
                                            : state.reportConfigForDc?.rackwise?.includes(
                                              "kwh"
                                            ) && (
                                              <td align="right" width={140}>
                                                {/* {(ele.type === "readings" &&
                                            ele.kwh) ||
                                            0} */}
                                                {ele.type === "readings" &&
                                                  toFixedValue(ele.kwh)}
                                              </td>
                                            )}
                                          {state.isRackwiseDataOnEdit &&
                                            state.indexRd === index
                                            ? state.reportConfigForDc?.rackwise?.includes(
                                              "kva"
                                            ) && (
                                              <td width={140}>
                                                <TextField
                                                  value={String(
                                                    state.rackwiseDataObj.kva
                                                  )}
                                                  type="number"
                                                  name="kva"
                                                  onChange={
                                                    handleRackwiseDataChange
                                                  }
                                                // className="width-100"
                                                />
                                              </td>
                                            )
                                            : state.reportConfigForDc?.rackwise?.includes(
                                              "kva"
                                            ) && (
                                              <td align="right" width={140}>
                                                {/* {(ele.type === "readings" && ele.kw) ||
                                          0} */}
                                                {ele.type === "readings" &&
                                                  toFixedValue((ele?.amps * 230) / 1000)}
                                              </td>
                                            )}
                                          {![2, 4, 5].includes(tokenData.role) && (
                                            <td align="center">
                                              {state.isRackwiseDataOnEdit &&
                                                state.indexRd === index ? (
                                                <React.Fragment>
                                                  <TooltipHost
                                                    content="Save"
                                                    calloutProps={{
                                                      gapSpace: 0,
                                                    }}
                                                  >
                                                    <span
                                                      onClick={() =>
                                                        onUpdateRackwiseData()
                                                      }
                                                    >
                                                      <Icon
                                                        path={mdiCheck}
                                                        size={0.8}
                                                        className="pointer"
                                                        color="green"
                                                      />
                                                    </span>
                                                  </TooltipHost>
                                                  &nbsp;&nbsp;
                                                  <TooltipHost
                                                    content="Cancel"
                                                    calloutProps={{
                                                      gapSpace: 0,
                                                    }}
                                                  >
                                                    <span
                                                      onClick={() =>
                                                        setState({
                                                          ...state,
                                                          isRackwiseDataOnEdit:
                                                            false,
                                                          indexRd: undefined,
                                                          rackwiseDataObj: {
                                                            date: new Date(),
                                                            breakerId: [],
                                                            customerRackId: "",
                                                            pduId: [],
                                                            rackId: "",
                                                            kw: undefined,
                                                            amps: undefined,
                                                            kwh: undefined,
                                                            kva: undefined,
                                                          },
                                                        })
                                                      }
                                                    >
                                                      <Icon
                                                        path={mdiClose}
                                                        size={0.8}
                                                        className="pointer"
                                                        color="red"
                                                      />
                                                    </span>
                                                  </TooltipHost>
                                                </React.Fragment>
                                              ) : (
                                                <React.Fragment>
                                                  <TooltipHost
                                                    content="Edit"
                                                    calloutProps={{
                                                      gapSpace: 0,
                                                    }}
                                                  >
                                                    <span
                                                      onClick={() =>
                                                        setState({
                                                          ...state,
                                                          isRackwiseDataOnEdit:
                                                            true,
                                                          indexRd: index,
                                                          rackwiseDataObj: {
                                                            ...state.rackwiseDataObj,
                                                            breakerId:
                                                              ele?.breakerId ||
                                                              [],
                                                            customerRackId:
                                                              ele?.customerRackId ||
                                                              "",
                                                            pduId:
                                                              ele?.pduId || [],
                                                            rackId:
                                                              ele?.rackId || "",
                                                            kw: ele?.kw || 0,
                                                            amps:
                                                              ele?.amps || 0,
                                                            kwh: ele?.kwh || 0,
                                                            kva: ele?.kva || 0,
                                                          },
                                                        })
                                                      }
                                                    >
                                                      <Icon
                                                        path={mdiPencil}
                                                        size={0.7}
                                                        className="pointer"
                                                        color={
                                                          THEME.palette
                                                            .themePrimary
                                                        }
                                                      />
                                                    </span>
                                                  </TooltipHost>
                                                </React.Fragment>
                                              )}
                                            </td>
                                          )}
                                        </>
                                      )}
                                    </tr>
                                    {state.rackwiseData.find((d: any) => d.type === "readings") &&
                                      state.rackwiseData.length === index + 1 &&
                                      state.reportConfigForDc?.rackwise
                                        ?.length > 0 && (
                                        <tr>
                                          <th colSpan={5}>Total</th>
                                          {state.reportConfigForDc?.rackwise?.includes(
                                            "amps"
                                          ) && (
                                              <th align="right">
                                                {toFixedValue(ele.ampsTotal || ampsTotalValue)}
                                              </th>
                                            )}
                                          {state.reportConfigForDc?.rackwise?.includes(
                                            "kw"
                                          ) && (
                                              <th align="right">
                                                {toFixedValue(ele.kwTotal || kwTotalValue)}
                                              </th>
                                            )}
                                          {state.reportConfigForDc?.rackwise?.includes(
                                            "kwh"
                                          ) && (
                                              <th align="right">
                                                {toFixedValue(ele.kwhTotal || kwhTotalValue)}
                                              </th>
                                            )}
                                          {state.reportConfigForDc?.rackwise?.includes(
                                            "kva"
                                          ) && (
                                              <th align="right">
                                                {toFixedValue(ele.kvaTotal || kvaTotalValue)}
                                              </th>
                                            )}
                                          {![2, 4, 5].includes(tokenData.role) && <th></th>}
                                        </tr>
                                      )}
                                  </>
                                );
                              }
                            )
                          ) : (
                            <tr>
                              <td
                                // colSpan={state.dedicatedData.length > 0 ? 9 : 8}
                                // colSpan={state.dedicatedData.length > 0 ? 8 : 7}
                                colSpan={9}
                                align="center"
                              >
                                <br />
                                <i style={{ color: "#135c8a" }}>
                                  No Data Found
                                </i>
                                <br />
                                <br />
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </Stack>
                )}
            </Stack.Item>
          </React.Fragment>
        ) : (
          <NoDataTile title="No Datacenter found for this customer"></NoDataTile>
        )}
      </Stack>
      {state.isViewReportDialogOpen && (
        <ViewUploadedReportDialog
          customerId={state.searchObj.customerId}
          datacenterId={state.searchObj.datacenterId as string}
          datacenterName={state.datacenterDropdown.find((d) => d.key === state.searchObj.datacenterId)?.text as string}
          date={state.searchObj.startDate}
          onDialogClose={() => handleReportDialogOpenClose(false)}
        />
      )}
    </React.Fragment>
  );
};

export default PduPowerTable;
